<template>    
    <div class="card card-primary card-outline card-outline-tabs">
        <div class="card-header p-0 border-bottom-0">
            <ul class="nav nav-tabs d-flex flex-column flex-md-row" id="custom-tabs-five-tab" role="tablist">
                <li class="nav-item">
                    <a 
                        :class="tab === 'precios' ? 'nav-link active' : 'nav-link'" 
                        class="text-center"
                        href="#"
                        @click.prevent="tab = 'precios'"
                    >
                        Configurar precios por regiones
                    </a>
                </li>
                <li class="nav-item" v-if="showRecintoAnexoTab">
                    <a 
                        :class="['nav-link', 'text-center', { 'active': tab === 'recintoAnexo' }]"
                        href="#"
                        @click.prevent="tab = 'recintoAnexo'"
                    >
                        Configurar precios por butacas/plazas
                    </a>
                </li>
                <li class="nav-item">
                    <a 
                        :class="['nav-link', 'text-center', { 'active': tab === 'descuentos' }]"
                        href="#"
                        @click.prevent="tab = 'descuentos'"
                    >
                        Configurar cupones de descuento
                    </a>
                </li>
                <li class="nav-item">
                    <a 
                        :class="['nav-link', 'text-center', { 'active': tab === 'promociones' }]"
                        href="#"
                        @click.prevent="tab = 'promociones'"
                    >
                        Promociones
                    </a>
                </li>
                <li class="nav-item" v-if="evento.place_obj.tipo_svg === 2">
                    <a 
                        :class="tab === 'visibilidadReducida' ? 'nav-link active' : 'nav-link'" 
                        href="#"
                        @click.prevent="tab = 'visibilidadReducida'"
                    >
                        Configurar butacas/plazas de visibilidad reducida
                    </a>
                </li>
            </ul>
        </div>
        <div class="card-body">
            <div class="tab-content">
                <div class="tab-pane fade active show">
                    <transition name="fade" mode="out-in">
                        <div key="1" class="overlay-wrapper" v-if="tab === 'precios'">
                            <Precios :evento_id="evento_id" :sesion_id="sesion_id"/>
                        </div>
                        <div key="2" class="overlay-wrapper" v-if="tab === 'descuentos'">
                            <Vouchers :event_id="evento_id" :session_id="sesion_id"/>
                        </div>
                        <div key="3" class="overlay-wrapper" v-if="tab === 'promociones'">
                            <Promociones :event_id="evento_id" :session_id="sesion_id"/>
                        </div>
                        <div key="4" class="overlay-wrapper" v-if="tab === 'visibilidadReducida' && evento.place_obj.tipo_svg === 2">
                            <DescuentoButacas :evento="evento"
                                              :evento_id="Number(evento_id)"
                                              :sesion_id="Number(sesion_id)"
                            />
                        </div>
                        <div key="5" class="overlay-wrapper" v-if="tab === 'recintoAnexo'">
                            <PreciosPlazas v-if="evento.place_obj.tipo_svg === 1" :place="evento.place_obj" />
                            <PreciosButacas 
                                v-else-if="evento.place_obj.tipo_svg === 2"
                                :evento="evento"
                                :evento_id="Number(evento_id)"
                                :sesion_id="Number(sesion_id)"
                            />
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>              
</template>

<script>
    import Precios from './Precios';
    import Vouchers from './Vouchers';
    import Promociones from './Promociones';
    import PreciosPlazas from '@/components/backend/eventos/sesiones/plazas/PreciosPlazas';
    import PreciosButacas from '@/components/backend/eventos/sesiones/plazas/PreciosButacas';
    import DescuentoButacas from '../../../../../components/backend/eventos/sesiones/visibilidad-reducida/DescuentoButacas.vue';

    export default {
        props: ['evento_id', 'sesion_id', 'evento'],
        data() {
            return {
                tab: ''
            }
        },
        computed: {
            isTipoSvg2() {
                return this.evento.place_obj.tipo_svg === 2;
            },
            hasRegionesNormales() {
                return this.evento.place_obj.tipo_svg === 1 && !this.evento.tiene_regiones_anexas;
            },
            hasRegionesAnexas() {
                return this.evento.place_obj.tipo_svg === 1 && this.evento.tiene_regiones_anexas;
            },
            hasRegionesAnexasRegionNormal() {
                return this.evento.place_obj.tipo_svg === 2 && !this.evento.tiene_regiones_anexas && this.evento.tiene_plazas_recinto;
            },
            showPreciosTab() {
                return this.hasRegionesNormales || (this.evento.place_obj.tipo_svg === 1 && !this.evento.tiene_regiones_anexas) || this.hasRegionesAnexasRegionNormal;
            },
            showRecintoAnexoTab() {
                return this.isTipoSvg2 || this.hasRegionesAnexas || (this.evento.place_obj.tipo_svg === 1 && !this.evento.tiene_regiones_anexas);
            }
        },
        created() {
            this.tab = 'precios';
        //this.setInitialTab();
        },
        methods: {
        /* setInitialTab() {        
            if (this.hasRegionesAnexasRegionNormal || this.hasRegionesNormales) {
                this.tab = 'precios';
            } else if (this.isTipoSvg2 || this.hasRegionesAnexas) {
                this.tab = 'recintoAnexo';
            } else {
                this.tab = 'precios';
            }
        } */
        },
        components: {
            Precios, Vouchers, Promociones, PreciosPlazas, PreciosButacas, DescuentoButacas
        }
    }
</script>
